import styled from '@emotion/styled';
import { CodeInput as CodeInputPP } from '@paypalcorp/pp-react-code-input-weasley-v7';

export const StyledCodeInput = styled(CodeInputPP)`
  #ci-ciBasic-0,
  #ci-ciBasic-1,
  #ci-ciBasic-2,
  #ci-ciBasic-3,
  #ci-ciBasic-4,
  #ci-ciBasic-5 {
    height: 54px;
    min-height: unset;
    width: 42px;
  }
`;
